module.exports = __webpack_public_path__ + "static/media/1.3199dc65.jpeg";